import Endpoints from 'constants/endpoints';
import { ConsentStatus } from 'interfaces/consent-status.interface';
import focusBearApi from 'services/axios-config';
import { getOutdatedPolicies } from 'utils/policy-consent.util';

export const getConsentStatus = async () =>
  (await focusBearApi.get<ConsentStatus>(Endpoints.USER_CONSENT_STATUS)).data;

// Only the documents the gate listed: re-recording an up-to-date one would stamp an acceptance for a document the
// user wasn't shown.
export const acceptPolicies = async (status: ConsentStatus) => {
  const consents = getOutdatedPolicies(status).map(([type, policy]) => ({
    consent_type: type,
    consent_status: true,
    metadata: { policy_version: policy.current_version }
  }));
  await focusBearApi.put(Endpoints.USER_CONSENT, consents);
};
